import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { SourceDTO } from '@/dto/QuestionResponseDTO';
import { LegalAssistantMessage } from '@/models/messages';
import { removeTags, removeTagsAndContent, replaceInText } from '@/utils/utils';
import { marked } from 'marked';
import { computed, onBeforeMount, ref, watch } from 'vue';

interface Props {
  message: LegalAssistantMessage;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MarkDownComponent',
  props: {
    message: {}
  },
  setup(__props: any) {

const props = __props;
const messageWithSources = ref<LegalAssistantMessage | null>(null);
const hasSources = ref<boolean>(false);

onBeforeMount(() => {
  tryGetMessageWithSources();
});

watch(
  () => props.message,
  () => {
    tryGetMessageWithSources();
  },
  { deep: true }
);

function tryGetMessageWithSources(): void {
  try {
    messageWithSources.value = props.message;
    hasSources.value = !!messageWithSources.value.sources;
  } catch (err) {
    console.error('Error checking sources:', err);
  }
}

function getSourceTooltip(source: SourceDTO): string {
  if (source.section) {
    return `${source.title}\n${source.section}`;
  }
  return `${source.title}`;
}

function getSourcesToReplace(): Record<string, string> {
  const sources: Record<string, string> = {};

  if (!hasSources.value) {
    console.warn('No sources found in the message.');
    return sources;
  }

  if (messageWithSources.value) {
    const validSources = messageWithSources.value.sources!.filter(
      (s) => !!s.documentURL
    );

    validSources.forEach((source, i) => {
      const num = i + 1;
      sources[source.doc_id] =
        `<a class="reference-link" target="_blank" title="${getSourceTooltip(source)}" href="${source.documentURL}">${num}</a>`;
    });
  }

  return sources;
}

const compiledMarkdown = computed(() => {
  const compiled = hasSources.value
    ? marked(
        replaceInText(
          removeTags(props.message.text, ['referenceDoc'], true),
          getSourcesToReplace()
        )
      )
    : marked(removeTagsAndContent(props.message.text, ['referenceDoc']));
  return compiled;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "markdown-content",
    innerHTML: compiledMarkdown.value
  }, null, 8, _hoisted_1))
}
}

})